
import { Collection, getCollectionByHandle } from './collections';
import { formatCurrency } from './currency';
import { loadImageIntoElement } from './image';
import { getProductByHandle, Product } from './product';

export class ProductsPage {
    constructor() {

    }

    setupPageByCollection(collectionHandle: string) {

        // Set the document title
        document.title = collectionHandle.replace(/-/g, " ").toUpperCase() + " | Carta Di Sera";

        // Set the collection title
        {
            const productsCollectionTitle = document.getElementById("products-collection-title");
            if(!productsCollectionTitle) {
                throw new Error("Could not find element with id=products-collection-title");
            }
            productsCollectionTitle.innerText = collectionHandle.replace(/-/g, " ");
        }

        const productsContainer = document.getElementById("products-container") as HTMLDivElement;

        if(!productsContainer) {
            throw new Error("Could not find element with id=products-container");
        }

        const productsCollectionDescription = document.getElementById("products-collection-description") as HTMLParagraphElement;

        if(!productsCollectionDescription) {
            throw new Error("Could not find element with id=products-collection-description");
        }

        const placeholderCardsArr = new Array<HTMLElement>();

        // Make 20 placeholder product cards
        for(let i = 0; i < 20; i++) {
            placeholderCardsArr.push(this.createPlaceholderProductCard(productsContainer));
        }

        getCollectionByHandle(collectionHandle).then((collection: Collection) => {

            // Set the collection description
            productsCollectionDescription.innerText = collection.description;

            // Remove all the placeholder product cards
            for(let i = 0; i < placeholderCardsArr.length; i++) {
                productsContainer.removeChild(placeholderCardsArr[i]);
            }

            // Stroe array of container elements for the product cards
            const productCardContainers: Array<HTMLElement> = [];

            for(let productHandle of collection.productHandles) {
                // Make a div container element for the placeholder/product card
                const cardContainer = document.createElement("div");
                // Add the card container to the page inside the productsContainer
                productsContainer.appendChild(cardContainer);
                // Add the card container to the array
                productCardContainers.push(cardContainer);

                // Fetch the product by handle and create the product card
                getProductByHandle(productHandle).then((product) => {
                    this.createProductCard(product, cardContainer);
                });
            }
        });
    }

    createPlaceholderProductCard(cardContainer: HTMLElement) : HTMLElement {
        // Get the product card template
        const placeholderProductCardTemplate = document.getElementById("placeholder-product-card-template") as HTMLTemplateElement;
        // Clone the template
        const placeholderTemplate = placeholderProductCardTemplate.content.cloneNode(true) as DocumentFragment;
        // Get the root placeholder element with name="placeholder-product-card"
        const placeholderRootElem = placeholderTemplate.querySelector("[name=placeholder-product-card]") as HTMLDivElement;
        // Add the template root element to the page inside the cardContainer
        cardContainer.appendChild(placeholderRootElem);
        return placeholderRootElem;
    }

    createProductCard(product: Product, cardContainer: HTMLElement) {
        const placeholderProductCard = this.createPlaceholderProductCard(cardContainer);

        // Now create the actual product card using the product-card-template
        const productCardTemplate = document.getElementById("product-card-template") as HTMLTemplateElement;
        // Clone the template
        const template = productCardTemplate.content.cloneNode(true) as DocumentFragment;
        // Get the root element the class="product-image-link"
        const rootElem = template.querySelector(".product-image-link") as HTMLElement;
        if(!rootElem) {
            throw new Error("Could not find element with class='product-image-link' inside the product card template");
        }

        // Hide the root element
        rootElem.style.display = 'none';
        // Add the template root element inside th cardContainer
        cardContainer.appendChild(rootElem);

        // Get the product link element
        const productLinkElem = rootElem as HTMLElement;
        // Set the product link to the product URL
        const productUrl = new URL(`product?id=${product.handle}`, document.location.href);
        productLinkElem.setAttribute("href", productUrl.href);

        // Get the product name element that has the class="product-title"
        const productTitleElem = rootElem.querySelector(".product-title") as HTMLElement;
        if(!productTitleElem) {
            throw new Error("Could not find element with class='product-title' inside the product card template");
        }

        // Set the product name
        productTitleElem.innerText = product.name;

        // Get the product price element that has the class="product-price"
        const productPriceElem = rootElem.querySelector(".product-price") as HTMLElement;
        if(!productPriceElem) {
            throw new Error("Could not find element with class='product-price' inside the product card template");
        }

        // Set the product price
        productPriceElem.innerText = `From: ${formatCurrency(product.price.amount, product.price.currencyCode)}`;

        // Get the product image element with class="product-image"
        const productImageElem = rootElem.querySelector(".product-image") as HTMLImageElement;
        if(!productImageElem) {
            throw new Error("Could not find element with class='product-image' inside the product card template");
        }

        // Set the product image
        loadImageIntoElement(product.featuredImageThumb, productImageElem).then(() => {
            // Remove the placeholder from the cardContainer
            cardContainer.removeChild(placeholderProductCard);
            // Show the loaded collection
            rootElem.style.display = 'flex';
        });

    }

}